import React from 'react';
import { Button, SvgIcon, Tooltip } from '@mui/material';

import { canStartTrial, hasCanUsePlatesPermission } from '@paragon/login-tools';

import { useAppSelector } from '../../hooks';
import { ToolbarIconButton } from '../top/ToolbarIconButton';

interface Props {
  readonly condensed?: boolean;
}

export function AddPlatesButton({ condensed }: Props) {
  const canUsePlates = useAppSelector(hasCanUsePlatesPermission);
  const trialAvailable = useAppSelector(canStartTrial);

  if (canUsePlates) return null;

  const tooltipTitle = trialAvailable ? 'Start Free Trial to Add Plates' : 'Upgrade to Add Plates';
  const disabled = !canUsePlates;
  const icon = <AddPlatesIcon />;

  return condensed ? (
    <ToolbarIconButton title={tooltipTitle} icon={icon} disabled={disabled} />
  ) : (
    <Tooltip disableInteractive title={tooltipTitle}>
      <span>
        <Button
          size="small"
          variant="contained"
          color="primary"
          aria-label="add-plates"
          disabled={disabled}
          startIcon={icon}
        >
          Add Plates
        </Button>
      </span>
    </Tooltip>
  );
}

function AddPlatesIcon() {
  return (
    <SvgIcon>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 57 57"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        fillRule="nonzero"
        clipRule="evenodd"
        strokeLinejoin="round"
        strokeMiterlimit={2}
      >
        <g transform="matrix(1,0,0,1,-1998.36,-2320.23)">
          <g id="Add-Plate-Pair" transform="matrix(0.641901,0,0,0.642039,-42.4657,1620.47)">
            <g transform="matrix(0.713998,-3.05984e-16,-1.13661e-16,0.713998,1414.1,1089.91)">
              <g id="backing">
                <path
                  d="M2594.75,19.846L2594.75,102.555C2594.75,113.508 2585.85,122.401 2574.9,122.401L2492.2,122.401C2481.24,122.401 2472.35,113.508 2472.35,102.555L2472.35,19.846C2472.35,8.893 2481.24,0 2492.2,0L2574.9,0C2585.85,0 2594.75,8.893 2594.75,19.846Z"
                  fill="none"
                />
              </g>
            </g>
            <g>
              <g transform="matrix(0.086474,0,0,0.0521381,3074.42,1081.18)">
                <path
                  d="M1326.65,1494.78L1326.65,869.775L1908.03,869.775L1908.03,1494.78L1326.65,1494.78ZM1851.85,962.943L1382.82,962.943L1382.82,1401.62L1851.85,1401.62L1851.85,962.943Z"
                  fill="currentColor"
                />
              </g>
              <g transform="matrix(0.0264845,0,0,0.0521381,3156.45,1068.12)">
                <path
                  d="M1525.63,962.943L1326.65,962.943L1326.65,869.775L1525.63,869.775L1525.63,774.713L1709.04,774.713L1709.04,869.775L1908.03,869.775L1908.03,962.943L1709.04,962.943L1709.04,1058.01L1525.63,1058.01L1525.63,962.943Z"
                  fill="currentColor"
                />
              </g>
              <g transform="matrix(0.0132841,0,0,0.0521381,3222.98,1071.96)">
                <path
                  d="M1542.36,962.943L-962.328,962.943L-962.328,869.775L1908.03,869.775L1908.03,1524.79L1542.36,1524.79L1542.36,962.943Z"
                  fill="currentColor"
                />
              </g>
              <g transform="matrix(0.0132841,0,0,0.0521381,3231.62,1063.32)">
                <path
                  d="M1542.36,962.943L-962.328,962.943L-962.328,869.775L1908.03,869.775L1908.03,1524.79L1542.36,1524.79L1542.36,962.943Z"
                  fill="currentColor"
                />
              </g>
              <g transform="matrix(0.0132422,0,0,0.0521381,3179.53,1099.29)">
                <rect x="1326.65" y="869.775" width="581.379" height="93.168" fill="currentColor" />
              </g>
              <g transform="matrix(0.0132422,0,0,0.0521381,3182.93,1090.99)">
                <rect x="1326.65" y="869.775" width="581.379" height="93.168" fill="currentColor" />
              </g>
              <g transform="matrix(0.0132422,0,0,0.0521381,3194.56,1090.99)">
                <rect x="1326.65" y="869.775" width="581.379" height="93.168" fill="currentColor" />
              </g>
              <g transform="matrix(0.0132422,0,0,0.0521381,3191.16,1099.29)">
                <rect x="1326.65" y="869.775" width="581.379" height="93.168" fill="currentColor" />
              </g>
              <g transform="matrix(0.0132422,0,0,0.0521381,3206.18,1090.99)">
                <rect x="1326.65" y="869.775" width="581.379" height="93.168" fill="currentColor" />
              </g>
              <g transform="matrix(0.0132422,0,0,0.0521381,3202.78,1099.29)">
                <rect x="1326.65" y="869.775" width="581.379" height="93.168" fill="currentColor" />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
}
